/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { SamlUiInfo } from './SamlUiInfo';
const Saml2ProviderParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['metadataUrl', codecString, 'metadata_url'],
    ['uiInfo', SamlUiInfo, 'ui_info'],
]);
export class Saml2Provider extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Saml2ProviderParser.decode(input).map(res => new Saml2Provider(res));
    }
    static unsafeDecode(input) {
        return Saml2Provider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Saml2ProviderParser.encode(data);
    }
    static schema() {
        return Saml2ProviderParser.schema();
    }
}
